<template>
  <layout>
    <div class="w-full sm:w-1/2 mx-auto mb-0 mt-4 px-4 py-2 text-left">

      <div class="max-w-lg mb-5 border-b border-gray-300 pb-4">
        <p class="text-lg mb-2 sm:text-xl font-extralight flex items-center">
          <Link :href="route('control-panel.workshops.index')"><svg xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg></Link>
          Workshops &amp; Umfragen
        </p>


        <progress-tabs :active-index="1" :disable-more="true"></progress-tabs>


        <!-- customer: start -->
        <div>
          <label class="block text-sm pl-3 mb-2">Kunde</label>
          <input type="text" v-model="form.customer_name"
            class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 sm:mr-2 sm:py-2 rounded-md block sm:inline w-full  shadow-none sm:text-sm focus:ring-markencode-blue mb-3"
            placeholder="" />
        </div>

        <div v-if="form.errors.customer_name" class="text-xs text-markencode-red">{{ form.errors.customer_name }}</div>
        <!-- customer: end -->


        <!-- project: start -->
        <div>
          <label class="block text-sm pl-3 mb-2">Projekt</label>
          <input type="text" v-model="form.project_name"
            class="form-input bg-white border-gray-200 border-solid focus:border-markencode-blue focus:ring-transparent px-3 py-1.5 sm:mr-2 sm:py-2 rounded-md block sm:inline w-full  shadow-none sm:text-sm focus:ring-markencode-blue mb-3"
            placeholder="" />
        </div>
        <!-- project: end -->


        <!-- session_type: start -->
        <div class="mt-2 mb-5 flex items-center">
          <label
            class="w-1/2 flex space-x-2 cursor-pointer items-center justify-center rounded-l-md px-2 py-1.5 text-sm focus:outline-none sm:flex-1"
            :class="form.session_type == 'workshop' ? 'ring-0 bg-markencode-blue text-white hover:bg-markencode-blue' : 'ring-1 ring-gray-300 bg-white text-gray-900 hover:bg-gray-50'">
            <input type="radio" name="session_type" v-model="form.session_type" value="workshop" class="sr-only">
            <session-type-icon session-type="workshop"
            :classes="form.session_type == 'workshop' ? 'text-white' : 'text-gray-700'"
            ></session-type-icon>
            <span>Workshop</span>
          </label>

          <label
            class="w-1/2 flex space-x-2 cursor-pointer items-center justify-center rounded-r-md px-2 py-1.5 text-sm focus:outline-none sm:flex-1"
            :class="form.session_type == 'diy_workshop' ? 'ring-0 bg-markencode-blue text-white hover:bg-markencode-blue' : 'ring-1 ring-gray-300 bg-white text-gray-900 hover:bg-gray-50'">
            <input type="radio" name="session_type" v-model="form.session_type" value="diy_workshop" class="sr-only">
            <session-type-icon session-type="diy_workshop"
            :classes="form.session_type == 'diy_workshop' ? 'text-white' : 'text-gray-700'"
            ></session-type-icon>
            <span>Umfrage</span>
          </label>

        </div>
        <!-- session_type: end -->


        <!-- introtext: start -->
        <div><label class="block text-sm pl-3 mb-2">Begrüßungstext | Startscreen</label>
          <textarea v-model="form.introtext" rows="4" class="
                shadow-sm
                focus:ring-markencode-blue focus:border-markencode-blue
                mt-1
                mb-2
                block
                w-full
                text-sm
                border border-gray-300
                rounded-md
                placeholder:text-gray-400"></textarea>
        </div>
        <!-- introtext: end -->




        <!-- show qr code: start -->
        <div class="flex items-center px-2 h-12">
          <!-- focus:ring-2 focus:ring-markencode-blue focus:ring-offset-2 -->
          <button id="cy_show_answers" type="button" @click="toggleShowQrCode"
            class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none ring-0"
            role="switch" aria-checked="false">
            <!-- <span class="sr-only">"Bitte teilen Sie diesen Code mit anderen"</span> -->
            <span aria-hidden="true" class="pointer-events-none absolute h-full w-full rounded-md"></span>

            <span aria-hidden="true"
              class="pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
              :class="form.show_qr_code ? 'bg-markencode-blue' : 'bg-gray-200'
                "></span>

            <span aria-hidden="true"
              class="pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
              :class="form.show_qr_code ? 'translate-x-5' : 'translate-x-0'"></span>
          </button>

          <span class="ml-3 text-sm" id="annual-billing-label font-medium text-gray-900" v-text="showQrCodeText">
          </span>
        </div>
        <!-- show qr code: end -->

        <!-- <horizontal-divider /> -->

        <!-- session logo upload: start -->
        <!-- <div>
          <session-logo-upload :session="session" @logoSettingsUpdated="logoSettingsUpdated"></session-logo-upload>
        </div> -->
        <!-- session logo upload: end -->





      </div>


      <div class="max-w-lg w-full flex items-end justify-end">
        <button type="submit" @click="submit" 
          class="inline-flex justify-center bg-brandpreneurship-dark-gray w-full sm:w-min rounded-md border border-transparent px-4 py-2 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
          :class="disabled ? 'opacity-50 cursor-default' : 'hover:bg-black focus:outline-none focus:border-black opacity-100 cursor-pointer'"
          >
          SPEICHERN
        </button>
      </div>



    </div>

  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import draggable from 'vuedraggable';
import SessionLogoUpload from '@/Pages/ControlPanel/Shared/SessionLogoUpload';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import ProgressTabs from '@/Pages/ControlPanel/Workshops/Shared/ProgressTabs';
import SessionTypeIcon from '@/Pages/ControlPanel/Shared/SessionTypeIcon.vue';

export default {
  components: {
    Layout,
    draggable,
    SessionLogoUpload,
    HorizontalDivider,
    ProgressTabs,
    SessionTypeIcon,
  },

  props: ['translations'],

  data() {
    return {
      form: this.$inertia.form({
        customer_name: '',
        project_name: '',
        session_type: null,
        introtext: '',
        show_qr_code: true,
        logo_position: 'center',
        logo_size: 'm',
      }),
    };
  },

  methods: {
    toggleShowQrCode() {
      this.form.show_qr_code = !this.form.show_qr_code;
    },

    submit() {
      if (this.disabled) {
        return;
      }

      this.form.post(
        this.route('control-panel.workshops.store'),
        {}
      );
    },

    logoSettingsUpdated(settings) {
      this.form.logo_position = settings?.position || 'center';
      this.form.logo_size = settings?.size || 'm';
    },
  },

  computed: {
    showQrCodeText() {
      if (!this.form.show_qr_code) {
        return 'QR-Code und "Bitte teilen"-Hinweis ist nun ausgeblendet.';
      }

      return 'QR-Code und "Bitte teilen"-Hinweis werden jetzt angezeigt.';
    },

    disabled() {
      // return false;

      if (!this.form.customer_name || !this.form.project_name ||  !this.form.session_type) {
        return true;
      }

      return false;
    },
  },
};
</script>